import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  border: 2px solid #b6b6b6;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  max-height: ${132/16}rem;

  > svg {
    width: ${32 / 16}rem;
    height: ${32 / 16}rem;
  }

  .delete-icon {
    color: #e00000;
    width: ${16 / 16}rem;
    height: ${16 / 16}rem;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    opacity: 0;
    transform: scale(0.9);
    pointer-events: none;
    transition: opacity 250ms ease, transform 250ms ease;
  }

  &:hover {
    .delete-icon {
      opacity: 1;
      transform: scale(1);
      pointer-events: auto;
    }
  }
`;

export const Filename = styled.p`
  margin-top: 12px;
  font-size: ${14 / 16}rem;
  text-align: center;
  color: #606060;
`;
